import styleToObject from 'style-to-object';
import camelcase from 'camelcase';

const getStyleObject = (elementStyle) => {
  if (typeof elementStyle === 'string') {
    // consider incoming inline styles
    let styleObject = styleToObject(elementStyle);

    // change all keys to camelcase for jsx
    styleObject = Object.keys(styleObject).reduce((updatedObject, key) => {
      const value = styleObject[key];
      updatedObject[camelcase(key)] = value;
      return updatedObject;
    }, {});

    return styleObject;
  }

  // return empty object if there's no inline style defined
  // returning null will break the editor and your heart
  return elementStyle || {};
};

export default  getStyleObject;
